import React, { useState } from 'react';

interface WhatsAppContactProps {
  className?: string;
}

const WhatsAppContact: React.FC<WhatsAppContactProps> = ({ className = '' }) => {
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [message, setMessage] = useState('');
  
  // Get configuration from environment variables
  const isWhatsAppEnabled = process.env.REACT_APP_WHATSAPP_ENABLED === 'true';
  const studioPhone = process.env.REACT_APP_STUDIO_PHONE || '07927281013';
  
  // Don't render if WhatsApp is disabled
  if (!isWhatsAppEnabled) {
    return null;
  }

  const formatPhoneForWhatsApp = (phone: string) => {
    // Remove spaces and convert UK number to international format
    const cleaned = phone.replace(/\s/g, '');
    if (cleaned.startsWith('07')) {
      return '44' + cleaned.substring(1);
    }
    return cleaned;
  };

  const handleSendMessage = () => {
    if (!message.trim()) return;
    
    const whatsappPhone = formatPhoneForWhatsApp(studioPhone);
    const encodedMessage = encodeURIComponent(message.trim());
    const whatsappUrl = `https://wa.me/${whatsappPhone}?text=${encodedMessage}`;
    
    window.open(whatsappUrl, '_blank');
    setMessage('');
    setShowMessageBox(false);
  };

  const handleQuickWhatsApp = () => {
    const whatsappPhone = formatPhoneForWhatsApp(studioPhone);
    const whatsappUrl = `https://wa.me/${whatsappPhone}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className={`${className}`}>
      <div className="space-y-3">
        <button
          onClick={handleQuickWhatsApp}
          className="w-full bg-emerald-800 hover:bg-emerald-900 text-white font-medium py-3 px-4 rounded-lg transition-colors flex items-center justify-center space-x-2"
        >
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
          </svg>
          <span>Open WhatsApp</span>
        </button>

        <button
          onClick={() => setShowMessageBox(!showMessageBox)}
          className="w-full bg-gray-700 hover:bg-gray-600 text-white font-medium py-3 px-4 rounded-lg transition-colors flex items-center justify-center space-x-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
          <span>{showMessageBox ? 'Hide Message Box' : 'Send a Message'}</span>
        </button>

        {showMessageBox && (
          <div className="space-y-3 pt-2">
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Type your message to the studio..."
              className="w-full bg-gray-700 text-white placeholder-gray-400 rounded-lg p-3 resize-none focus:outline-none focus:ring-2 focus:ring-green-500"
              rows={3}
            />
            <button
              onClick={handleSendMessage}
              disabled={!message.trim()}
              className="w-full bg-emerald-800 hover:bg-emerald-900 disabled:bg-gray-600 disabled:cursor-not-allowed text-white font-medium py-2 px-4 rounded-lg transition-colors"
            >
              Send via WhatsApp
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default WhatsAppContact;
